import { render, staticRenderFns } from "./course-card.vue?vue&type=template&id=d45c925c&"
import script from "./course-card.ts?vue&type=script&lang=ts&"
export * from "./course-card.ts?vue&type=script&lang=ts&"
import style0 from "./course-card.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports